import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import React from 'react';
import { IImpersonationContextComponentProps } from '../../../../../models';
import { AutomationEditorStep } from '../../../../../models/Automations';
import { IConnectionTypeComponentProps } from '../../../../containers/templates/EditCampaign/context';
import { bs } from '../../../../styles/styles';
import { Collapsible } from '../../../Collapsible';
import { InputFieldError } from '../../../InputFieldError';
import { AdvancedOptionsButton, AutomationStepCardTextingInput } from '../presentation';
import { styleSheet } from '../styles';
import { ContactFilterOption } from './ContactFilterOption';
import { StepSendFromOption } from './StepSendFromOption';

interface TextingStepConfigProps extends IImpersonationContextComponentProps, IConnectionTypeComponentProps {
	step: AutomationEditorStep;
	canEdit: boolean;
	templateId: string;
	errorMessage: string | null;
	trigger: Api.IAutomationTrigger;
	schedule: Api.IAutomationStepSchedule;
	skipStepContactFilter: Api.IContactsFilterRequest;
	saveSenderOptions: (option: Api.ISendFromOptions, sendToSender: boolean) => void;
	onClearErrorMessages: () => void;
	onStepChanged?: () => void;
	onSaveStep: (
		automationStep?: Api.IAutomationStep,
		newSchedule?: Api.IAutomationStepSchedule,
		loggingEventParams?: Api.IDictionary<string | number | boolean>
	) => Promise<any>;
	onFilterChange: (filter: Api.IContactsFilterRequest) => void;
	index: number;
}

export function TextingStepConfig(props: TextingStepConfigProps) {
	const {
		step,
		canEdit,
		errorMessage,
		trigger,
		schedule,
		skipStepContactFilter,
		saveSenderOptions,
		onClearErrorMessages,
		onStepChanged,
		onSaveStep,
		onFilterChange,
		connectionTypes,
		impersonationContext,
		index,
		templateId,
	} = props;

	const automationStep = step.automationStep as Api.ITextingAutomationStep;

	const [advancedOptionsToggled, setAdvancedOptionsToggled] = React.useState(() => {
		const hasSendOptionSelected =
			!!step.automationStep?.sendFromOptions &&
			step.automationStep.sendFromOptions.mode !== Api.SendEmailFrom.CurrentUser;
		return skipStepContactFilter?.criteria || hasSendOptionSelected;
	});

	return (
		<>
			<div className={css(styleSheet.fieldLabel)}>
				Text content: &nbsp;
				<span className={css(bs.required)}>*</span>
			</div>
			<InputFieldError errorMessage={errorMessage}>
				<AutomationStepCardTextingInput
					index={index}
					onRequestClearErrorMessages={onClearErrorMessages}
					onRequestSave={onSaveStep}
					onStepChanged={onStepChanged}
					schedule={schedule}
					step={automationStep}
					trigger={trigger}
					templateId={templateId}
					stepId={step.automationStep?.id}
					impersonationContext={impersonationContext}
				/>
			</InputFieldError>
			<AdvancedOptionsButton
				isCollapsed={!advancedOptionsToggled}
				onClick={() => setAdvancedOptionsToggled(!advancedOptionsToggled)}
			/>
			<Collapsible isCollapsed={!advancedOptionsToggled}>
				<div className={css(styleSheet.advancedOptionsContent)}>
					<>
						<StepSendFromOption
							step={step}
							onSave={saveSenderOptions}
							connectionTypes={connectionTypes}
							impersonationContext={impersonationContext}
						/>
						<ContactFilterOption
							canEdit={canEdit}
							impersonationContext={impersonationContext}
							skipStepContactFilter={skipStepContactFilter}
							stepUuid={step.uuid}
							stepIsBusy={step.automationStep.isBusy}
							onFilterChange={onFilterChange}
						/>
					</>
				</div>
			</Collapsible>
		</>
	);
}
